import { ContactFragment, isContactFragment } from './ContactFragment'

import detailedGroupFragmentRawString from '../DetailedGroupFragment.graphql'

export const detailedGroupFragmentString = detailedGroupFragmentRawString

export type DetailedGroupFragment = {
  __typename: 'Group'
  id: string
  name: string
  description: string
  members: ContactFragment[]
}

export const isDetailedGroupFragment = (
  fragment: any,
): fragment is DetailedGroupFragment =>
  fragment &&
  fragment.__typename === 'Group' &&
  typeof fragment.id === 'string' &&
  typeof fragment.name === 'string' &&
  typeof fragment.description === 'string' &&
  Array.isArray(fragment.members) &&
  fragment.members
    .slice(0, 5)
    .reduce(
      (accum: any, next: any) => accum && (isContactFragment(next) as boolean),
      true,
    )
